import React, { useContext, useState } from 'react';
import {
	IStyleSettingsCarouselUploaderContext,
	StyleSettingsCarouselUploaderContext,
} from '../styleSettingsCarouselUploaderState/styleSettingsCarouselUploaderContext';
import { ICustomItemsOfGroups } from 'types';
import { useBlobDownload } from 'hooks/useBlobDownload';
import { FileField } from 'components/EntityForm/FileField';
import { FileUploadButton } from 'components/UploaderAndDownloader/FileUploadButton';

const savedFileName = 'document';

interface IProps {
	pdfItem?: ICustomItemsOfGroups;
	maxFileSizeMB: number;
	onUpload: (fileId: string) => void;
	onDelete: () => void;
}

export const PDFBlockNew: React.FC<IProps> = ({ pdfItem, maxFileSizeMB, onUpload, onDelete }) => {
	const { changeTypeOfErrorModalWindow } = useContext<IStyleSettingsCarouselUploaderContext>(
		StyleSettingsCarouselUploaderContext,
	);
	const [uploadedFileName, setUploadedFileName] = useState<Nullable<string>>(null);
	const downloadFile = useBlobDownload({
		filePath: pdfItem?.filePath ?? null,
		fileExtension: 'pdf',
		fileName: savedFileName,
		onError: () => changeTypeOfErrorModalWindow('fileDownloadError'),
	});

	const handleUpload = ({ fileId, file }: { fileId: string; file: File }) => {
		onUpload(fileId);
		setUploadedFileName(file.name);
	};

	const handleDelete = () => {
		onDelete();
		setUploadedFileName(null);
	};

	return (
		<div className="flex flex-col gap-2" data-test="PDFSection">
			{pdfItem && uploadedFileName && (
				<FileField fileName={uploadedFileName} testId="PDFFile" onDelete={handleDelete} />
			)}
			{pdfItem && !uploadedFileName && pdfItem.filePath && (
				<FileField
					fileName={`${savedFileName}.pdf`}
					testId="PDFFile"
					onDownload={downloadFile}
					onDelete={handleDelete}
				/>
			)}
			<div className="flex">
				<FileUploadButton
					hasFile={!!pdfItem}
					accept={['pdf']}
					maxFileSizeMB={maxFileSizeMB}
					testId="uploadReloadButton"
					onUpload={handleUpload}
					onSizeExceeded={() => changeTypeOfErrorModalWindow('pdfFileSizeExceeded')}
					onInvalidFormat={() => changeTypeOfErrorModalWindow('invalidPdfFormat')}
					onUploadError={() => changeTypeOfErrorModalWindow('fileUploadError')}
				/>
			</div>
		</div>
	);
};
